export default __webpack_public_path__ + "static/media/bg1_m.f84dad78.png";